export default __webpack_public_path__ + "static/media/Ire.e4c86594.jpg";